import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, Calendar, Dumbbell, BarChart3, Sparkles, Settings } from 'lucide-react';

export function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/schedule', icon: Calendar, label: 'Schedule' },
    { path: '/workouts', icon: Dumbbell, label: 'Workouts' },
    { path: '/stats', icon: BarChart3, label: 'Stats' },
    { path: '/ai-coach', icon: Sparkles, label: 'AI Coach' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="layout-outer">
      <div className="layout-phone-frame">
        {/* Main content */}
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>

        {/* Bottom Tab Bar */}
        <div
          className="flex items-center justify-around px-2 border-t"
          style={{
            height: '72px',
            backgroundColor: '#27272A',
            borderColor: '#3F3F46',
          }}
        >
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const active = isActive(tab.path);
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                className="flex flex-col items-center justify-center gap-1 transition-colors"
                style={{
                  minWidth: '44px',
                  minHeight: '44px',
                  color: active ? '#FF6B35' : '#71717A',
                }}
              >
                <Icon size={22} strokeWidth={active ? 2.5 : 2} />
                <span style={{ fontSize: '10px', fontWeight: 500 }}>
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
